/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {useState} from 'react';

export function useOpenComment() {
    const [openCommentIndex, setOpenCommentIndex] = useState<number | null>(null);

    function getCommentProps(index: number, canShow: boolean) {
        return {
            showComment: openCommentIndex === index,
            setShowComment: (show: boolean) => {
                if (canShow) setOpenCommentIndex(show ? index : null);
            },
        };
    }

    function toggleComment(index: number, canShow: boolean) {
        if (canShow) {
            setOpenCommentIndex(openCommentIndex === index ? null : index);
        } else {
            setOpenCommentIndex(null);
        }
    }

    return {getCommentProps, toggleComment};
}
